export default "__VITE_ASSET__C2xh_41g__"